const ISO6346_VALUES: Record<string, number> = {
    '0': 0, '1': 1, '2': 2, '3': 3, '4': 4, '5': 5, '6': 6, '7': 7, '8': 8, '9': 9,
    'A': 10, 'B': 12, 'C': 13, 'D': 14, 'E': 15, 'F': 16, 'G': 17, 'H': 18, 'I': 19, 'J': 20,
    'K': 21, 'L': 23, 'M': 24, 'N': 25, 'O': 26, 'P': 27, 'Q': 28, 'R': 29, 'S': 30, 'T': 31,
    'U': 32, 'V': 34, 'W': 35, 'X': 36, 'Y': 37, 'Z': 38
};

export const validateContainerChecksum = (value: string): boolean => {
    if (value == null || value === '') return true;
    const normalized = value.replace(/[\s-]/g, '').toUpperCase();
    if (normalized.length !== 11) return false;
    if (!/^[A-Z0-9]{11}$/.test(normalized)) return false;
    let sum = 0;
    for (let i = 0; i < 10; i++) {
        const charVal = ISO6346_VALUES[normalized[i]];
        if (charVal === undefined) return false;
        sum += charVal * Math.pow(2, i);
    }
    const checkDigit = sum % 11;
    const expected = checkDigit === 10 ? 0 : checkDigit;
    const actual = parseInt(normalized[10], 10);
    if (isNaN(actual)) return false;

    return actual === expected;
};

export const validateContainer = (value: string): { isValid: boolean; formattedValue: string } => {
    if (value == null || value === '') {
        return { isValid: false, formattedValue: value };
    }

    const formattedValue = value.replace(/\s+/g, '').toUpperCase();
    const isValid = /^[A-Z]{4}\d{7}$/.test(formattedValue);

    return { isValid, formattedValue };
};
